import React from 'react';
import { connect } from 'react-redux';
import { Box, Skeleton } from '@mui/material'


const CardSkeleton = () => {

    return (
        <Box display='flex' sx={{ p: 1 }}>
            <Box className='main-wrapper' style={{ marginRight: "5px" }}>
                <div className='img-wrapper'>
                    <Skeleton className='skeleton-img' variant="rectange" />
                </div>
            </Box>
        </Box >
    );
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, {

})(CardSkeleton);